// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"styles_itemWrapper__kXUXv","listItem":"styles_listItem__4DYGt"};